import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/node_modules/@mui/material/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/node_modules/@mui/material/Typography/Typography.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/broadsheet/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/journal-site/_partials/header/journal-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/journal-site/home/journal-home.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/src/components/main-site/home/journals-section/journals-section.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/src/components/main-site/home/lead/lead-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/main-site/home/search-bar/search-bar.tsx");
